import { Component, OnInit, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { ScreenBreakpoint } from 'src/app/theme/utils/screen-breakpoint';
import { SidenavMenuService } from 'src/app/theme/components/sidenav-menu/sidenav-menu.service';
import { Meta, Title } from '@angular/platform-browser';
// import { MainlayoutComponent } from '../../main-layout/mainlayout/mainlayout.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { checkDeliveryCalenderAndCutOffTime, checkDeliveryCalendarOrderStatus,  checkCutoffDate,  checkCutoffTime, } from '../../../../theme/utils/util-functions';
import { ApiService } from 'src/app/shared/services/api.service';
import { CustomizeMenuService } from 'src/app/shared/services/cutomizemenu.service';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav', { static: true }) sidenav: any;
  public sidenavOpen:boolean = true;
  public sidenavMenuItems = {};
  isMobile = false;
  public isShowCutOffMessage: boolean = false;
  storeDetails = null;
  deliveryCalendar = null;
  cutOffDateTime = null;
  subService;
  featureTags = {} ;
  formattedDateTime = "";
  totalTaxCollectedAmount: number = 0;
  private destroy$ = new Subject<void>();
  menuTitle: string = '';

  public links = [
    { name: 'Account Dashboard', href: 'dashboard', icon: 'dashboard' },
    { name: 'Edit Profile', href: 'information', icon: 'info' },
    { name: 'Delivery Preferences', href: 'addresses', icon: 'location_on' },
    { name: 'Manage Payment Options', href: 'payment', icon: 'payment' },
    { name: 'Order History', href: 'orders', icon: 'shopping_cart' },  
    { name: 'Recurring Items', href: 'recurring', icon: 'add_shopping_cart' },  
    // { name: 'Logout', href: '/sign-in', icon: 'power_settings_new' },    
  ];

  constructor(
    public router:Router,
    private route: ActivatedRoute,
    private screenBreakpoint: ScreenBreakpoint,
    public sidenavMenuService: SidenavMenuService,
    // public mainlayoutComponent: MainlayoutComponent,
    private meta: Meta,
    private title: Title,
    private datePipe: DatePipe,
    private subscription: SubscriptionService,
    private decimalPipe: DecimalPipe,
    private apiService: ApiService,
    private cutomizeMenuServie: CustomizeMenuService,
    public sharedDataService: SharedDataService

  ) {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
   }

  ngOnInit() {
    if(window.innerWidth < 960){
      this.sidenavOpen = false;
    };
    this.isMobile = this.screenBreakpoint.checkScreenBreakpoint('screen and (max-width: 959px)');
    this.sidenavMenuService.getSidenavMenuItems().subscribe(result => {
      if(result['response']['status'] === 1) {
        // if(this.featureTags){
          
          this.sidenavMenuItems =  this.cutomizeMenuServie.cutomizeMenuDetails(result['response']['data']['menus']['menus']);
          
        // }else{
        //   this.sidenavMenuItems = result['response']['data']['menus']['menus'];
        //   console.log(this.sidenavMenuItems,'account elsee');
        // }
      }
    });
    this.subService = this.subscription.getSubject().subscribe(val => {
      if(val['value'] === 'check cutoff message') {
        this.storeDetails = JSON.parse(sessionStorage.getItem('store'));
        this.deliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar'));
        this.cutOffDateTime = JSON.parse(sessionStorage.getItem('cutoff'));
        this.formattedDateTime =  this.cutOffDateTime ? this.datePipe.transform(this.cutOffDateTime[0]["storeCutOffTime"], 'MM/dd/yy h:mm a') : "";
        this.openCutOffMessage();
      }
    });
  }
  ngOnDestroy() {
    !!this.subService && this.subService.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize')
  public onWindowResize():void {
    (window.innerWidth < 960) ? this.sidenavOpen = false : this.sidenavOpen = true;
  }

  ngAfterViewInit(){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) { 
        if(window.innerWidth < 960){
          this.sidenav && this.sidenav.close(); 
        }
      }                
    });
    if (this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
      this.sharedDataService.passEvent$.subscribe(data => {
        console.log('Received data:', data);
        if (data['name'])
          this.menuTitle = data['name'];
      });
    }

  }
  handleChange(event) {
    if(event['title']) {
      this.router.navigate([event['title']['href']]);
    } else if(event['name']) {
      if(event['href'] !== null && !event['category_url']) {
        this.router.navigate([event['href']]);
      } else if (event['href'] !== null && event['category_url']) {
        this.router.navigate(['/categories', event['category_url']]);
      }
    } else {
      this.router.navigate(['categories']);
    }
  }

  openCutOffMessage() {
    let cut_off_message = sessionStorage.getItem('cut_off_message');
    let delivery_date = sessionStorage.getItem('selected_delivery_date');
    let deliveryCalendar = JSON.parse(sessionStorage.getItem('event_details'));
    let selectedDeliveryCalendar;
     if (deliveryCalendar && Array.isArray(deliveryCalendar)) {
      selectedDeliveryCalendar = deliveryCalendar.find(
            (event: any) => event.event_date === delivery_date
        ) || {};
        console.log(selectedDeliveryCalendar);
        if(selectedDeliveryCalendar){
          this.isShowCutOffMessage = this.cutOffDateTime[0]['storeDeliveryDate'] === selectedDeliveryCalendar['event_date'] && !selectedDeliveryCalendar['create_order'];
        }else{
          this.isShowCutOffMessage = false;
        }
        
    }
    
  }

  closeCutOffMessage() {
    this.isShowCutOffMessage = false;
    sessionStorage.setItem('cut_off_message', 'hide');
  }
}
